import { render, staticRenderFns } from "./ActivateTciButton.vue?vue&type=template&id=6ab13f98&"
import script from "./ActivateTciButton.vue?vue&type=script&lang=js&"
export * from "./ActivateTciButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports